import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import locales from './locales';

interface TransferFieldProps {
  fieldName: string;
  value?: string;
}

const TransferField: FC<TransferFieldProps> = ({ fieldName, value }) => (
  <Flex flex={1} flexDirection="column" gap="space-8">
    <Text size="sm">{fieldName}</Text>
    <Text {...(value && { fontWeight: 'weight-500' })} variant="primary">
      {value || locales.notSpecified}
    </Text>
  </Flex>
);
export default TransferField;
